<template>
  <div class="bodycontent">
    <div class="page_title">
      短信模板
    </div>
    <div class="page_form">
      <div class="options">
        <el-button type="primary" size="medium" icon="el-icon-plus" @click="showSelect=true">从模板库中添加</el-button>
      </div>
      <el-table :header-cell-style="setTableHeader" :data="selectedList">
        <el-table-column label="模板id" prop="template_id"></el-table-column>
        <el-table-column label="类型" prop="show_type"></el-table-column>
        <el-table-column label="模板名称" prop="name"></el-table-column>
        <el-table-column label="模板内容" prop="content" min-width="300px"></el-table-column>
        <el-table-column label="操作" width="90px">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_bottom" v-if="false">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showSelect">
      <el-table :header-cell-style="setTableHeader" :data="allList" v-loading="selectLoading">
        <el-table-column label="模板id" prop="id"></el-table-column>
        <el-table-column label="类型" prop="show_type"></el-table-column>
        <el-table-column label="模板名称" prop="name"></el-table-column>
        <el-table-column label="模板内容" prop="content" min-width="200px"></el-table-column>
        <el-table-column label="操作" width="90px">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="addItem(scope.row.id)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page2"
          :total="total2"
          :page-size="10"
          @current-change="handleCurrentChange2">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mySMSTemplate,allSMSTemplate,selectSMSTemplate,delSMSTemplate } from "@/api/set";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      selectedList: [], // 已选择的模板列表
      allList: [], // 全部的模板
      showSelect: false, // 选择模板弹窗
      selectLoading: false, // 选择时loading
      page: 1, // 已选择列表分页
      total: 0, // 已选择列表总数
      page2: 1, // 全部
      total2: 0, // 全部
    };
  },
  mounted(){
    this.init();
    this.getData();
  },
  methods:{
    init(){ // 获取化模板库列表
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page2
      }
      allSMSTemplate(data).then(res => {
        if(res.code == 200){
          this.allList = res.data.data;
          this.total2 = res.data.total;
          this.allList.forEach(item => {
            item.show_type = item.type == 1? "验证码":item.type == 2? "营销短信":"通知短信"
          })
        }
      })
    },
    getData(){ // 获取已选择的模板列表
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      mySMSTemplate(data).then(res => {
        if(res.code == 200){
          this.selectedList = res.data;
          this.selectedList.forEach(item => {
            item.show_type = item.type == 1? "验证码":item.type == 2? "营销短信":"通知短信"
          })
        }
      })
    },
    handleCurrentChange(val){ // 已选择
      this.page = val;
      this.getData();
    },
    handleCurrentChange2(val){ // 全部
      this.page2 = val;
      this.init();
    },
    addItem(id){ // 从模板库添加
      this.selectLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      }
      selectSMSTemplate(data).then(res => {
        this.selectLoading = false;
        if(res.code == 200){
          this.showSelect = false;
          this.getData();
          this.$message({
            type: "success",
            message: "添加成功"
          })
        }else {
          this.$message(res.msg)
        }
      })
    },
    delItem(id){ // 删除已选择模板
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: id
        };
        delSMSTemplate(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      })
      .catch();
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form{
    padding-top: 20px;
    font-size: 14px;
    .options{
      margin-bottom: 20px;
    }
    .list_item{
      line-height: 30px;
      span{
        margin-right: 15px;
        color: #409eff;
      }
    }
  }
  .page_bottom{
    padding-top: 10px;
  }
  .input_box{
    width: 320px;
  }
  .submit_button{
    margin-top: 30px;
    text-align: center;
  }
}
</style>